import React, { Component } from "react";
import styles from "./detailBloodStationWaitingDonor.module.scss";
import Spinner from "../../spinner";
import CustomCarousel from "../../ui/customCarousel";
import { TRecipientData } from "../../../stores/RecipientStore";
import { DonorNeedCard } from "../../DonorNeeds/DonorNeeds";
import BlockContainer from "../../mainPageBlocks/blockContainer";

export default class DetailBloodStationWaitingDonor extends Component<
  any,
  any
> {
  props: {
    addressneed: TRecipientData[];
  };

  responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1920 },
      items: 5,
      slidesToSlide: 5,
    },
    desktop: {
      breakpoint: { max: 1919, min: 1440 },
      items: 4,
      slidesToSlide: 4,
    },
    laptop: {
      breakpoint: { max: 1439, min: 1200 },
      items: 3,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1199, min: 768 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 767, min: 360 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  render() {
    const { props, responsive } = this;
    const { addressneed } = props;
    if (!addressneed) {
      return <Spinner toggled={true} />;
    }

    return (
      <BlockContainer
        isGrid
        isSSR={true}
        title={"Срочно нужны доноры"}
        linkText={"Найти донора"}
        linkUrl={"/helpme/"}
      >
        <CustomCarousel
          responsive={responsive}
          partialVisible={false}
          draggable={true}
          swipeable={true}
          arrows={true}
          infinite={true}
          dots={true}
          removeArrowOnDeviceType={["mobile"]}
        >
          {addressneed.map((item) => (
            <div className={styles.Card_DetailNeed} key={item.id}>
              <DonorNeedCard data={item} />
            </div>
          ))}
        </CustomCarousel>
      </BlockContainer>
    );
  }
}
